import React, { useEffect, useState } from 'react';
import './index.less';
import '@jd/jmtd-charts/dist/themes/default.css'; // 默认皮肤
import '../yx.css';
import '../yx-pro.css';
import '../yx-extra.css';
import apis from '../../apis';
import {  Button, Icon, Title, CardHeader, CardSection, CardTabs, Tabs, Message } from '@jd/jmtd';
import SalesEffect from '@/pages/mvp-panel/participant-data/components/sales-effect';
import SkuAnalysis from '@/pages/mvp-panel/participant-data/components/sku-analysis';

const allItem = { label: <div clsTag={'h|keycount|yx_center_hzcp_1678258944439|6'}>全部商品</div>, value: -1 ,  skuNum: null, skuName: '全部商品'}
const addItem =     {
  label: <div clsTag={'h|keycount|yx_center_hzcp_1678258944439|8'}><Icon className='jmti-plus'/>新建商品组</div>,
  value: 'add',
}

export default function (props) {
  const [selTab, setSelTab] = useState(-1);
  const [tabList, setTabList] = useState([allItem, addItem]);
  const [selObj, setSelObj] = useState(allItem);

  useEffect(() => {
    apis.queryGoodsGroupList({pageSize: 100, filterSkuZero: true}).then((res) => {
      const {
        ret,
        data: { list = [] },
      } = res;
      if (ret === '0') {
        console.log({list})
        const groupList = list.map(item => ({label:<div clsTag={'h|keycount|yx_center_hzcp_1678258944439|6'}>{item.name}</div>, value: item.id, skuNum:item.skuNum, skuName: item.name}));
        groupList.unshift(allItem);
        groupList.push(addItem)
        setTabList(groupList)
        setSelTab(-1)
        setSelObj(allItem)
      }
    });
  },[])

  const handleChangeTab = (val) =>{
    if(val != 'add'){
      setSelTab(val)
      const selItem = tabList.filter((item)=>(item.value === val))
      setSelObj(selItem?.[0])
    }else{
      props.toProductGroup({create: true})
    }
  }

  const handleLog = (val) =>{
    window.log('yx_center_hzcp_1680082497624', val)
  }

  const handleCustomLog = (val) =>{
    window.log(...val)
  }

  return (
    <div className="goods-tab-card-bg">
      {
        props?.filter?.userType === 'placeErp' &&
          <>
            <CardHeader className="goods-tab-title" right={<Button semantic='primary' outline onClick={props.toProductGroup} clsTag={'h|keycount|yx_center_hzcp_1678258944439|7'}>管理商品组</Button>}>
          <span>
            商品数据
          </span>
            </CardHeader>
            <CardSection className="goods-tab-section">
              <Tabs
                data={tabList}
                value={selTab}
                onChange={(val)=>{handleChangeTab(val)}}
                type={CardTabs}
                operation={<Button clsTag={'h|keycount|yx_center_hzcp_1678258944439|8'} onClick={props.toProductGroup} startIcon={<Icon className='jmti-plus' />}></Button>}
              />
              <SalesEffect filter={props.filter} erp={props.erp} skuGroupId={selTab} selObj={selObj}/>
              {/*<SkuAnalysis filter={props.filter} dataScopeFilter={props.dataScopeFilter} originFilter={props.originFilter} onChangeOriginFilter={props.onChangeOriginFilter} skuGroupId={selTab} selObj={selObj} erp={props.erp} handleLog={handleLog} handleCustomLog={handleCustomLog}/>*/}
            </CardSection>
          </>
      }
      <SkuAnalysis filter={props.filter} dataScopeFilter={props.dataScopeFilter} originFilter={props.originFilter} onChangeOriginFilter={props.onChangeOriginFilter} skuGroupId={selTab} selObj={selObj} erp={props.erp} handleLog={handleLog} handleCustomLog={handleCustomLog}/>

    </div>
  );
}
